import { render, staticRenderFns } from "./ClinicianPatientsListWrapper.vue?vue&type=template&id=646fe5bc"
import script from "./ClinicianPatientsListWrapper.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientsListWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports